import { PropsWithChildrenAndClass } from 'types/sharedComponents';
import { cn } from 'utils/styles';

interface Props extends PropsWithChildrenAndClass {
  open?: boolean;
}

const Details = ({ children, className, open }: Props) => {
  return (
    <details className={cn(`py-4 flex flex-col group`, className)} open={open}>
      {children}
    </details>
  );
};

export default Details;
